/* eslint-disable import/no-anonymous-default-export */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faStar } from "@fortawesome/free-solid-svg-icons";
import { convertDate } from "../../../../_helpers/dateFormatter";
import useAssessmentVideos from "./useAssessmentVideos";
import VideoPlayer from "../../../../_uiComponents/VideoPlayerBasic";
import { Spinner } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

export default function ({
  publicAssessmentKitsLists,
  onAssessmentKitVideosClick,
  assessementKitsLoading
}) {
  const {
    expandedAssessmentKitId,
    assessmentKitQuestionsVideos,
    onAssessmentKitExpandClick,
    expandKitLoading,
  } = useAssessmentVideos();
  return (
    <div className="mx-auto bg-white border-radius-10 p-3 p-md-4 border">
      <h3 className="mb-4">Interview Videos</h3>
      {Array.isArray(publicAssessmentKitsLists) &&
        publicAssessmentKitsLists.length ? (
        assessementKitsLoading ?
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
          </div> :
          <div className="mt-4">
            <Accordion
              defaultActiveKey={
                expandedAssessmentKitId && expandedAssessmentKitId.toString()
              }
              className="mb-3"
            >
              {Array.isArray(publicAssessmentKitsLists) &&
                publicAssessmentKitsLists.map((item) => (
                  <Accordion.Item
                    eventKey={item?.id}
                    onClick={() => onAssessmentKitExpandClick(item?.id)}
                    className="border mb-3 border-radius-10"
                  >
                    <Accordion.Header className="border-0 w-100">
                      <li className="d-flex flex-wrap justify-content-between align-items-start p-2 p-md-3">
                        <div className="d-flex flex-grow-1 mb-1">
                          <FontAwesomeIcon icon={faAngleRight} className="mr-2 mr-md-3" />
                          <div className="px-0">
                            <h3 className="mb-2 text-capitalize">{item?.assessment_id && item.assessment_id?.title}</h3>
                            <p className="mb-1 fs-smallest mt-3 font-weight-medium">
                              <span className=" border pl-2 pr-0 py-1 rounded-lg mr-2">Skills{" "}
                                {item?.assessment_id && item.assessment_id?.skills &&
                                  item.assessment_id.skills.map((i) =>
                                    <span className="bg-grey rounded-lg px-2 my-1 mr-1">
                                      {i?.skill_id && i.skill_id?.skill}
                                    </span>
                                  )}

                              </span>
                              <span className=" border px-2 py-1 rounded-lg"> Questions{" "}
                                <span className="bg-grey rounded-lg px-2 my-1">{item?.assessment_id && item.assessment_id.total_questions}
                                </span>
                              </span>
                            </p>
                          </div>
                        </div>
                        <div>
                          <button
                            className="btn text-primary w-100 font-weight-medium p-0"
                            onClick={() =>
                              onAssessmentKitVideosClick(
                                item?.id,
                              )
                            }
                          >
                            View all
                          </button>
                        </div>
                      </li>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="interview-videos p-3 border-top">
                        <div className="videos-list">
                          {expandKitLoading ? (
                            <Spinner animation="border" variant="primary" />
                          ) : (
                            Array.isArray(assessmentKitQuestionsVideos) &&
                              assessmentKitQuestionsVideos.length ?
                              <div className="row">
                                {Array.isArray(assessmentKitQuestionsVideos) &&
                                  assessmentKitQuestionsVideos.map((question) => (
                                    <div className="col-md-6 col-xl-4 mb-4">
                                      <div
                                        to="/view-assessment-video"
                                        className="interview-video-box h-100"
                                      >
                                        <div className="video-box bg-white rounded-lg shadow-sm h-100">
                                          <div className="top d-flex align-items-center p-2">
                                            <div className="user-img">
                                              <img
                                                src="/assets/images/user.png"
                                                alt="user img"
                                              />
                                            </div>
                                            <h5 className="mx-2 mb-0">
                                              {question?.question_id && question.question_id.topic_id &&
                                                question.question_id.topic_id
                                                  ?.topic_name &&
                                                question.question_id.topic_id.topic_name.substring(
                                                  0,
                                                  100
                                                )}
                                            </h5>
                                            <p className="h5 font-weight-normal text-grey-4  ml-auto mb-0">
                                              {convertDate(question?.created_at)}
                                            </p>
                                          </div>
                                          <div className="video-thumbnail">
                                            <VideoPlayer
                                              playbackId={question?.video_asset_id}
                                              playBackDuration={0}
                                            />
                                          </div>
                                          <div className="video-info p-2">
                                            <h4 className="mb-2">
                                              {question?.question_id &&
                                                question.question_id
                                                  ?.question_text &&
                                                question.question_id.question_text.substring(
                                                  0,
                                                  30
                                                ) + "..."}
                                            </h4>
                                            <div className="d-flex align-items-center justify-content-between">
                                              {Array.isArray(question?.candidate_response_rating_id) && 
                                              question?.candidate_response_rating_id && question.candidate_response_rating_id.length > 0 ?
                                                <span>
                                                  <FontAwesomeIcon
                                                    icon={faStar}
                                                    className="mr-2 text-warning"
                                                  />
                                                  <span>
                                                    {question?.candidate_response_rating_id &&
                                                      question?.candidate_response_rating_id.map((item) =>
                                                        <span>{item?.rating_value}</span>)
                                                    }
                                                  </span>
                                                </span>
                                                : <span></span>}
                                              <span className="fs-smallest bg-grey px-2 border rounded-lg text-primary ">
                                                {question?.question_id && question.question_id?.skill_id &&
                                                  question.question_id.skill_id.skill}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                              : <h4 className="text-danger text-center">No Videos yet!</h4>
                          )}
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
      ) : (
        <div className="text-center">
          <h4 className="text-danger">No Interview Video Found!</h4>
        </div>
      )}
    </div>
  );
}
